import type { ParagraphThreeColsText as ParagraphThreeColsTextData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layout 16 — `PARAGRAPH_THREE_COLS_TEXT_LAYOUT`: 3 kolumny tekstu z tytułami.
 *
 * Mapping pól -> kolumny (zgodnie z legacy template
 * `c_descriptive_page_layout_16_default_modern.imp`):
 *   - col 1: `name`   + `text`
 *   - col 2: `name_1` + `text_1`
 *   - col 3: `name_2` + `text_2`
 *
 * `name` NIE jest nagłówkiem akapitu — to nagłówek pierwszej kolumny (vs np.
 * layout 1 gdzie `name` to tytuł całego akapitu).
 */
export function ParagraphThreeColsText({
  paragraph,
  t,
}: {
  paragraph: ParagraphThreeColsTextData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <div className={styles.colsThree}>
        <div>
          {paragraph.name && (
            <h2 className={styles.paragraphSubName}>{paragraph.name}</h2>
          )}
          <HtmlText html={paragraph.text} />
        </div>
        <div>
          {paragraph.name_1 && (
            <h2 className={styles.paragraphSubName}>{paragraph.name_1}</h2>
          )}
          <HtmlText html={paragraph.text_1} />
        </div>
        <div>
          {paragraph.name_2 && (
            <h2 className={styles.paragraphSubName}>{paragraph.name_2}</h2>
          )}
          <HtmlText html={paragraph.text_2} />
        </div>
      </div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}
